/* global globals:false */
import React, { Component } from 'react';
import forOwn from 'lodash/forOwn';
import get from 'lodash/get';
import ImagesCropping from '../../components/image/ImagesCropping';
import CroppingBottomNav from '../../components/image/CroppingBottomNav';

const apiWebroot = get(globals, 'apiWebroot', '/');

class ImagesCroppingContainer extends Component {
  state = {
    status: 'Loading images...',
    saving: false,
    images: null,
    total: null,
    timeRange: '1-week',
    domain: 'All',
    thumbSize: 'o-m/',
    fullSize: 'h/',
  };

  fetchImages = this.fetchImages.bind(this);

  changeTimeRange = this.changeTimeRange.bind(this);

  changeDomain = this.changeDomain.bind(this);

  saveCenteredImage = this.saveCenteredImage.bind(this);

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.fetchImages();
  }

  fetchImages(timeRangeTarget, domainTarget) {
    let { timeRange, domain } = this.state;
    if (timeRangeTarget) {
      timeRange = timeRangeTarget;
    }
    if (domainTarget) {
      domain = domainTarget;
    }

    const uB = 'images/center';
    const tP = '?time=';
    const dP = '&domain=';

    const headers = {
      credentials: 'same-origin',
    };
    fetch(apiWebroot + uB + tP + timeRange + dP + domain, headers)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status === 'ok') {
          this.setState({
            images: data.images,
            status: 'Ready',
            total: data.total,
          });
        } else {
          this.setState({
            images: null,
            status: data.status,
            total: null,
          });
        }
      })
      .catch((error) => {
        this.setState({
          images: null,
          status: 'Image fetch failed',
          total: null,
        });
        console.log('Image fetch failed: ', error);
      });
  }

  changeTimeRange(e) {
    this.setState({
      timeRange: e.target.value,
      images: null,
      total: null,
      status: 'Loading images...',
    });
    this.fetchImages(e.target.value);
  }

  changeDomain(e) {
    this.setState({
      domain: e.target.value,
      images: null,
      status: 'Loading images...',
    });
    this.fetchImages(false, e.target.value);
  }

  saveCenteredImage(imageData) {
    this.setState({ saving: true });
    const stateData = {
      images: null,
      total: null,
      saving: false,
    };
    const headers = {
      Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      Cache: 'no-cache',
    };

    const params = new URLSearchParams();
    params.append('member_id', imageData.member_id);
    params.append('filename', imageData.filename);

    forOwn(imageData.options.custom_crop, (v, k) => {
      const paramName = `options[custom_crop][${k}]`;
      params.append(paramName, v);
    });

    fetch(`${get(globals, 'apiWebroot', '/')}images/generate`, {
      headers,
      method: 'POST',
      body: params,
      credentials: 'same-origin',
    })
      .then((resp) => resp.json())
      .then((response) => {
        if (response.status === 'ok') {
          fetch(`${apiWebroot}images/updateCenteredContent`, {
            credentials: 'same-origin',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image_id: imageData.image_id }),
          })
            .then((resp) => resp.json())
            .then((data) => {
              if (data.status === 'ok') {
                const { images } = this.state;
                const filtered = images.filter((img) => img.filename !== imageData.filename);
                if (filtered.length) {
                  this.setState((prevState) => ({
                    images: filtered,
                    status: 'Ready',
                    total: prevState.total - 1,
                    saving: false,
                  }));
                } else {
                  stateData.status = 'Loading images...';
                  this.setState(stateData);
                  this.fetchImages();
                }
              } else {
                stateData.status = data.status;
                this.setState(stateData);
              }
            })
            .catch((error) => {
              stateData.status = 'Image update failed';
              this.setState(stateData);
              console.log('Image update failed: ', error);
            });
        } else {
          stateData.status = response.status.status;
          this.setState(stateData);
        }
      })
      .catch((error) => {
        stateData.status = 'Image cropping failed';
        this.setState(stateData);
        console.log('Image cropping failed: ', error);
      });
  }

  render() {
    const {
      thumbSize,
      fullSize,
      status,
      images,
      saving,
      domain,
      timeRange,
      total,
    } = this.state;

    const { imagesBaseUri } = globals;

    const imageUrlBase = imagesBaseUri + thumbSize;
    const imageToCropUrlBase = imagesBaseUri + fullSize;

    let content;
    if (status === 'Ready') {
      content = (
        <ImagesCropping
          images={images}
          saveCentered={this.saveCenteredImage}
          imageUrlBase={imageUrlBase}
          toCropUrlBase={imageToCropUrlBase}
          saving={saving}
        />
      );
    } else {
      content = <p className="mbl">{status}</p>;
    }

    let count = null;
    if (images) {
      count = images.length;
    }

    return (
      <div className="admin-monitor block group block--padded mbm">
        {content}
        <CroppingBottomNav
          changeDomain={this.changeDomain}
          domain={domain}
          changeTimeRange={this.changeTimeRange}
          timeRange={timeRange}
          count={count}
          total={total}
        />
      </div>
    );
  }
}

export default ImagesCroppingContainer;
